import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import { useCompany } from '../contexts/CompanyContext';

export function useValidateResourceCompany() {
  const { company } = useCompany();
  const history = useHistory();
  const [isSwitchingCompany, setIsSwitchingCompany] = useState(false);

  const validateResourceCompany = useCallback((
    resourceCompanyId: number | undefined | null,
    resourceCompanyUid?: string | null,
    fallbackPath: string = '/sale-support',
    resourceName: string = 'factura o documento de venta'
  ) => {
    // Si company.current no está cargado todavía, esperar
    if (!company.current?.id || company.current.id === 0) return true;
    if (!resourceCompanyId && !resourceCompanyUid) return true;

    const matchesId = resourceCompanyId ? company.current.id === resourceCompanyId : true;
    const matchesUid = resourceCompanyUid ? company.current.uid === resourceCompanyUid : true;

    if (!matchesId || !matchesUid) {
      // Buscar la empresa dueña en las empresas permitidas del usuario
      const targetCompany = company.list?.find(
        (c: any) => (resourceCompanyId && c.id === resourceCompanyId) || (resourceCompanyUid && c.uid === resourceCompanyUid)
      );

      if (targetCompany && targetCompany.uid) {
        setIsSwitchingCompany(true);
        message.loading({
          content: `El documento pertenece a "${targetCompany.name}". Cambiando de empresa...`,
          key: 'company-switch',
          duration: 3,
        });
        const url = new URL(globalThis.location.href);
        url.searchParams.set('company', targetCompany.uid);
        globalThis.location.href = url.toString();
        return false;
      } else {
        message.error(`No tienes permisos para ver este ${resourceName} (pertenece a otra empresa).`);
        history.push(fallbackPath);
        return false;
      }
    }

    return true;
  }, [company.current?.id, company.current?.uid, company.list, history]);

  return {
    validateResourceCompany,
    isSwitchingCompany,
  };
}

